import { getSubPageData } from '../../../utils/prismicRouteHelpers'
import { INewsArticle, ISubPage, PrismicDocumentTypes } from '../../../prismicTypes'
import { Language } from '../../../types/Types'
import { QueryOptions } from '@prismicio/client/types/ResolvedApi'
import { getSubPages } from '../../../utils/prismicRouteHelpers'
import { getSlicesFromDocument } from '../../../utils/prismicHelpers'
import Subpage from '../../../components/Pages/SubPage'
import { routingPaths } from '../../../data/Constants'
import { NewsArticle } from '../../../components/Pages/NewsArticle'

interface IProps {
  params: { page: string; subpage: string }
  preview: boolean
  previewData: QueryOptions
  locale: Language
}

interface ITemplateProps {
  subpage: ISubPage.IProps | INewsArticle.IProps
}

export async function getStaticProps({ params, previewData, locale }: IProps) {
  const { ref } = previewData || {}

  const {
    props: { subpage, navigation, footer },
  } = await getSubPageData(ref, locale, params.page, params.subpage)

  const subPageSlices = await getSlicesFromDocument(subpage)
  let returnProps = { props: { navigation, footer, subpage: undefined } }
  if (subpage.type == PrismicDocumentTypes.SubPage) {
    returnProps.props.subpage = { ...subpage, data: { ...subpage.data, body: subPageSlices } }
  } else if (PrismicDocumentTypes.NewsArticle) {
    returnProps.props.subpage = { ...subpage, data: { ...subpage.data, body: subPageSlices } }
  }

  return returnProps
}

const SubPageIndex = ({ subpage }: ITemplateProps) => {
  if (subpage.type == PrismicDocumentTypes.SubPage) return <Subpage page={subpage as ISubPage.IProps} />
  else if (subpage.type == PrismicDocumentTypes.NewsArticle)
    return <NewsArticle articlePage={subpage as INewsArticle.IProps} />
}

export async function getStaticPaths() {
  const subpages = await getSubPages()

  const pagesPaths = subpages.map((page) => {
    let parentId
    switch (page.type) {
      case PrismicDocumentTypes.NewsArticle:
        parentId = routingPaths.news
        break

      default:
        parentId = page.data.link_to_parent.uid
        break
    }
    return `/${parentId}/${page.uid}`
  })

  const paths = [...pagesPaths]
  return { paths, fallback: false }
}
export default SubPageIndex
